import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { makerVariant } from '../variant-resolver.tsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';

gsap.registerPlugin(ScrollTrigger);

const GRID_DATA = [
  {
    title: 'CREATION',
    color: '#6D28D9',
    iconBg: '#D6BAFA',
    items: [
      { label: 'AI builder', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/ai-builder-v1x85f20i3o.png' },
      { label: 'Storefront builder', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/storefront-builder-5k4buqh2ltd.png' },
      { label: 'Page builder', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/page-builder-kk76wuok09n.png' },
      { label: 'Category pages', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/category-pages-vmj40ov2upp.png' },
      { label: 'Product pages', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/product-pages-xejurqjg7yf.png' },
      { label: 'Media generation', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/media-generation-sfrub3xgs6.png' },
      { label: 'Figma import', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/figma-import-uoc7jba7j6r.png' },
      { label: 'Brand guides', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/brand-guides-faakbzyrnbl.png' }
    ]
  },
  {
    title: 'DELIVERY',
    color: '#C2410C',
    iconBg: '#FF7C4D',
    items: [
      { label: 'Insights', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/insights-02lx5etaamah.png' },
      { label: 'A/B testing', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/ab-testing-51gn69fomkd.png' },
      { label: 'Enhanced content', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/enhanced-content-m19ox7u27x8.png' },
      { label: 'Hosting', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/hosting-eszpuga5rfi.png' },
      { label: 'Optimized media', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/optimized-media-nxh2k5dyq8.png' },
      { label: 'Localization', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/localization-o2a03v1hu8m.png' },
      { label: 'Ad spend analytics', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/ad-spend-analytics-417h04vvtyt.png' }
    ]
  },
  {
    title: 'EXPERIENCE',
    color: '#0E7490',
    iconBg: '#94E1F7',
    items: [
      { label: 'Personalization', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/personalization-tdmkzr35sk.png' },
      { label: 'Visual search', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/visual-search-n4p7rt3v0xs.png' },
      { label: 'Conversational commerce', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/conversational-commerce-ygs3dxiosf.png' },
      { label: 'Voice shopping', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/voice-shopping-gqprcfgv8xt.png' },
      { label: 'Shoppable media', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/shoppable-media-5s6k0dswv7t.png' },
      { label: 'Visual navigation', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/visual-navigation-xuqgid7qfwn.png' },
      { label: 'Context memory', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/context-memory-w518kxsjewd.png' }
    ]
  },
  {
    title: 'AGENTS',
    color: '#727066',
    iconBg: '#E6E5DD',
    items: [
      { label: 'MCP Server', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/mcp-server-1xgnby85jgz.png' },
      { label: 'Web MCP', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/web-mcp-n8m4qvjhrp.png' },
      { label: 'API access', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/api-access-h3v9vc1w2ps.png' },
      { label: 'Structured data (JSON-LD)', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/structured-data-ppmnoszj0yi.png' },
      { label: 'Semantic search', icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/semantic-search-csmda5xoyyc.png' }
    ]
  }
];

const TAB_MAP: Record<string, string> = {
  'CREATION': 'CREATION',
  'DELIVERY': 'DELIVERY',
  'EXPERIENCE': 'EXPERIENCE',
};

type GridCardProps = {
  data: typeof GRID_DATA[0];
  isHorizontal?: boolean;
  isMobileOrTablet: boolean;
  hoveredCol: string | null;
  setHoveredCol: (v: string | null) => void;
  colIndex?: number;
};

const GridCard = ({ data, isHorizontal = false, isMobileOrTablet, hoveredCol, setHoveredCol, colIndex }: GridCardProps) => {
  const isCompact = isMobileOrTablet;
  const hasLink = !isMobileOrTablet && !!TAB_MAP[data.title];
  const go = () => {
    window.dispatchEvent(new CustomEvent('greatstore-tab-goto', { detail: { tab: TAB_MAP[data.title] } }));
    setTimeout(() => {
      document.getElementById('features')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };
  return (
    <div style={{
      padding: isMobileOrTablet ? '24px 20px' : '0',
      border: 'none',
      borderRadius: '0',
      backgroundColor: isMobileOrTablet ? '#F2F0E9' : 'transparent',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div
        data-gs-el={!isMobileOrTablet ? 'col-header' : undefined}
        onClick={hasLink ? go : undefined}
        role={hasLink ? 'button' : undefined}
        tabIndex={hasLink ? 0 : undefined}
        onKeyDown={hasLink ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } } : undefined}
        onMouseEnter={() => hasLink && setHoveredCol(data.title)}
        onMouseLeave={() => hasLink && setHoveredCol(null)}
        style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 500,
          fontSize: isCompact ? '12px' : '14px',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          color: data.color,
          marginBottom: '20px',
          cursor: hasLink ? 'pointer' : 'default',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          userSelect: 'none'
        }}
      >
        {data.title}
        {hasLink && (
          <span style={{
            opacity: hoveredCol === data.title ? 1 : 0,
            transition: 'opacity 0.18s ease',
            fontSize: '14px',
            lineHeight: 1
          }}>→</span>
        )}
      </div>
      <div style={{
        display: 'flex',
        flexDirection: isHorizontal && !isMobileOrTablet ? 'row' : 'column',
        flexWrap: isHorizontal && !isMobileOrTablet ? 'wrap' : 'nowrap',
        gap: isHorizontal && !isMobileOrTablet ? '14px 32px' : '14px'
      }}>
        {data.items.map((item, i) => (
          <div key={i} {...(!isMobileOrTablet && colIndex !== undefined ? { 'data-gs-col': String(colIndex) } : {})} style={{ display: 'flex', alignItems: isCompact ? 'flex-start' : 'center', gap: '10px' }}>
            <div aria-hidden="true" style={{
              width: '10px',
              height: '10px',
              backgroundColor: data.iconBg,
              flexShrink: 0
            }} />
            <span style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 500,
              fontSize: isCompact ? '12px' : '14px',
              letterSpacing: '0.04em',
              textTransform: 'uppercase' as const,
              color: '#091717',
              lineHeight: isCompact ? 1 : undefined
            }}>
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const NewGrid = ({ isMobileOrTablet }: { isMobileOrTablet: boolean }) => {
  const [hoveredCol, setHoveredCol] = useState<string | null>(null);
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isMobileOrTablet) return;
    const el = gridRef.current;
    if (!el) return;
    const ctx = (gsap as any).context(() => {
      const header = el.querySelector('[data-gs-el="header"]');
      const colHdrs = el.querySelectorAll('[data-gs-el="col-header"]');
      const divider = el.querySelector('[data-gs-el="divider"]');
      const agents = el.querySelector('[data-gs-el="agents"]');
      const itemGroups = [0, 1, 2].map(ci => el.querySelectorAll(`[data-gs-col="${ci}"]`));
      const all = [header, ...Array.from(colHdrs), ...itemGroups.flatMap(g => Array.from(g)), divider, agents].filter(Boolean);
      gsap.set(all, { opacity: 0, y: 16 });
      const timer = setTimeout(() => {
        const tl = (gsap as any).timeline({ scrollTrigger: { trigger: el, start: 'top 78%', once: true } });
        if (header) tl.to(header, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' });
        tl.to(colHdrs, { opacity: 1, y: 0, duration: 0.45, ease: 'power2.out', stagger: 0.04 }, '-=0.2');
        itemGroups.forEach((items, ci) => {
          tl.to(items, { opacity: 1, y: 0, duration: 0.32, ease: 'power2.out', stagger: 0.07 }, ci === 0 ? '+=0.05' : '-=0.18');
        });
        if (divider) tl.to(divider, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' }, '-=0.1');
        if (agents) tl.to(agents, { opacity: 1, y: 0, duration: 0.45, ease: 'power2.out' }, '-=0.2');
        ScrollTrigger.refresh();
      }, 300);
      return () => clearTimeout(timer);
    }, el);
    return () => ctx.revert();
  }, [isMobileOrTablet]);

  if (isMobileOrTablet) {
    return (
      <div style={{ width: '100%' }}>
        <div style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '20px',
          color: '#091717',
          marginBottom: '24px'
        }}>
          GreatStore Layers:
        </div>
        <div style={{ width: '100vw', marginLeft: 'calc(-50vw + 50%)' }}>
          <Swiper
            modules={[FreeMode]}
            freeMode={true}
            slidesPerView="auto"
            spaceBetween={16}
            style={{ padding: '0 16px' }}
          >
            {GRID_DATA.map((col, idx) => (
              <SwiperSlide key={idx} style={{ width: '78vw', maxWidth: '300px', height: 'auto' }}>
                <GridCard data={col} isMobileOrTablet={isMobileOrTablet} hoveredCol={hoveredCol} setHoveredCol={setHoveredCol} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    );
  }

  return (
    <div ref={gridRef} style={{ width: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column' }}>
      <div data-gs-el="header" style={{
        fontFamily: 'Instrument Sans, sans-serif',
        fontWeight: 400,
        fontSize: '20px',
        color: '#091717',
        marginBottom: '40px'
      }}>
        GreatStore Layers:
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '0 40px' }}>
        {GRID_DATA.slice(0, 3).map((col, idx) => (
          <div key={idx}>
            <GridCard data={col} isMobileOrTablet={isMobileOrTablet} hoveredCol={hoveredCol} setHoveredCol={setHoveredCol} colIndex={idx} />
          </div>
        ))}
      </div>

      <div data-gs-el="divider" style={{ marginTop: '40px', marginBottom: '40px', height: '1px', backgroundColor: 'rgba(9, 23, 23, 0.12)', width: '100%' }} />

      <div data-gs-el="agents">
        <GridCard data={GRID_DATA[3]} isMobileOrTablet={isMobileOrTablet} hoveredCol={hoveredCol} setHoveredCol={setHoveredCol} isHorizontal={true} />
      </div>
    </div>
  );
};

export const HumanAndAgent = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(() => typeof window !== 'undefined' ? window.innerWidth <= 1024 : false);

  useEffect(() => {
    const handleResize = () => setIsMobileOrTablet(window.innerWidth <= 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    // Target the <img> inside the wrapper div (avoids passing ref to BuildImageOptimizer)
    const imgEl = wrapperRef.current?.querySelector('img');
    if (!imgEl) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      gsap.set(imgEl, { opacity: 1, y: 0 });
      return;
    }

    // Own the initial hidden state via GSAP — no inline opacity:0 in markup
    // so the image is always visible as a fallback if GSAP never fires.
    gsap.set(imgEl, {
      opacity: 0,
      y: 32
    });
    const setupAnimation = () => {
      gsap.fromTo(imgEl, {
        opacity: 0,
        y: 32
      }, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: imgEl,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
    };

    // Hero asset and other images finish loading after useEffect, shifting
    // the layout and staling ScrollTrigger positions. Defer setup until the
    // page is fully loaded so positions are calculated against final layout.
    if (document.readyState === 'complete') {
      requestAnimationFrame(() => {
        setupAnimation();
        ScrollTrigger.refresh();
      });
    } else {
      window.addEventListener('load', () => {
        setupAnimation();
        ScrollTrigger.refresh();
      }, {
        once: true
      });
    }
    return () => ScrollTrigger.getAll().forEach((t: {
      kill(): void;
    }) => t.kill());
  }, []);
  return <section data-name="Human and Agent" data-nav-theme="light" style={{
    backgroundColor: '#FCFAF6',
    paddingBottom: !isMobileOrTablet ? 'clamp(60px, 8vw, 120px)' : undefined
  }} className="mt-0 mb-0 ml-0 mr-0 pl-0 pr-0 pt-0 pb-0">
      <div className="section-content" style={{
      maxWidth: '1360px',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: '40px',
      paddingRight: '40px',
      display: 'flex',
      justifyContent: 'flex-start'
    }}>
        {(makerVariant('diagramType', 'grid') as string) === 'grid' ? (
          <NewGrid isMobileOrTablet={isMobileOrTablet} />
        ) : (
          <div ref={wrapperRef}>
            <picture style={{
            display: 'block',
            maxWidth: '790px',
            width: '100%',
            margin: '0 auto'
          }}>
              <source media="(max-width: 767px)" srcSet="https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/mobile-diagram-xqc80tgjhb.png" />
              <img alt="Human and AI agent shopping experience" style={{
              maxWidth: '100%',
              display: 'block'
            }} src="https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/new-diagram-wp4nd2mkqmt.png" />
            </picture>
          </div>
        )}
      </div>
    </section>;
};